import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { RepresentanteNomePipe } from './representante-nome.pipe';
import { RepresentanteNomeSecundarioPipe } from './representante-nome-secundario.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RepresentanteNomePipe,
        RepresentanteNomeSecundarioPipe
    ],
    exports: [
        SharedModule,

        RepresentanteNomePipe,
        RepresentanteNomeSecundarioPipe
    ],
    providers: [
        RepresentanteNomePipe,
        RepresentanteNomeSecundarioPipe
    ]
})
export class RepresentantePipeSharedModule { }
